import { render, staticRenderFns } from "./sliderWrapper.vue?vue&type=template&id=92c1b228&scoped=true&"
import script from "./sliderWrapper.vue?vue&type=script&lang=js&"
export * from "./sliderWrapper.vue?vue&type=script&lang=js&"
import style0 from "./sliderWrapper.vue?vue&type=style&index=0&id=92c1b228&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c1b228",
  null
  
)

export default component.exports